import React from 'react'
import SignInForm from './Signin'
import SignUpForm from './Signup'
import firebaseConfig from './firebase.js';
import {useNavigate} from 'react-router-dom'
// import './Proceed.css'
export default function Proceed() {
  const navigate=useNavigate();
  function navi(){
    navigate('/SignInForm')
  }
  return (
    <div>
    <h1>Welcome to the Home Page</h1>
  {/*<Link to="/SignUpForm">Go to Sign Up Page</Link>
  <Link to="/SignInForm">Go to Sign In page</Link>*/}
    <button onClick={navi}>Sign In To Proceed</button>
    </div>
  )
}
